<div class="flex flex-col w-full h-full">
  @if (items(); as items) {
    <div class="overflow-auto flex flex-col gap-2 p-3 h-full">
      @for (item of items; track item.id) {
        <div class="relative" data-qa="cart-item" [attr.data-qa-type]="item.type">
          <button
            type="button"
            class="link-btn remove-btn"
            data-qa="cart-item-remove-button"
            (click)="$event.stopPropagation(); onRemoveItem(item.id)"
          >
            <mat-icon svgIcon="close" />
          </button>
          @if (item.type === 'tour') {
            <app-cart-tour-item-view [data]="item.data" [selectedFareCode]="item.selectedFareCode" />
          }
          @if (item.type === 'hotel') {
            <app-cart-hotel-item-view [data]="item.data" [transfer]="item.transfer" />
          }
          @if (item.type === 'avia') {
            <app-cart-avia-item-view [data]="item.data" />
          }
          @if (item.type === 'excursion') {
            <app-cart-excursion-item-view [data]="item.data" [pickupHotelName]="item.pickupHotelName" />
          }
        </div>
      }
      <div class="w-full mt-2">
        <button
          type="button"
          class="stroked-button w-full p-1 font-[400!important] h-[35px!important]"
          matRipple
          data-qa="cart-clear-button"
          (click)="onCartClear()"
        >
          {{ 'Clear all' | translate }}
        </button>
      </div>
    </div>

    @if (totalPrice(); as totalPriceData) {
      <div class="mt-auto">
        @if (totalPriceData?.totalPriceLoadingStatus?.status === 'loading') {
          <mat-progress-bar mode="indeterminate" class="w-full" data-qa="cart-total-loader" />
        }
        <div class="flex items-center justify-between border-top p-2">
          <div class="text-kz-primary font-bold w-full text-center" style="font-size: 1.2em" data-qa="cart-total-price">
            @if (totalPriceData?.totalPriceLoadingStatus?.status === 'loading') {
              ...
            } @else {
              {{ totalPriceData.totalPrice | priceFormat: totalPriceData.currency }}
            }
          </div>
          <div>
            @if (
              totalPriceData?.calcCheckoutResponse?.errorCode === 'HOTEL_DATES_INVALID' ||
              totalPriceData?.refreshPriceResult
            ) {
              <button
                type="button"
                color="primary"
                class="flex-row-reverse gap-3 font-normal h-[35px!important] opacity-50"
                mat-flat-button
                data-qa="cart-checkout-button"
                [attr.data-qa-blocked]="true"
                [matTooltip]="
                  (totalPriceData?.refreshPriceResult
                    ? 'One of the items in your cart is no longer available at this price. Please remove it to continue.'
                    : 'Your hotel stay must cover your entire travel period. Please update your check-in and check-out dates to match your travel dates.'
                  ) | translate
                "
              >
                <div>
                  {{ 'Checkout' | translate }}
                </div>
                <mat-icon svgIcon="arrow" color="white" />
              </button>
            } @else {
              <button
                type="button"
                color="primary"
                class="flex-row-reverse gap-3 font-normal h-[35px!important]"
                mat-flat-button
                data-qa="cart-checkout-button"
                [attr.data-qa-blocked]="false"
                [disabled]="totalPriceData?.totalPriceLoadingStatus?.status === 'loading'"
                (click)="onCheckout()"
              >
                <div>
                  {{ 'Checkout' | translate }}
                </div>
                <mat-icon svgIcon="arrow" color="white" />
              </button>
            }
          </div>
        </div>
        @if (totalPriceData?.refreshPriceResult) {
          <p class="px-2 text-xs text-red-500" data-qa="cart-price-unavailable-error">
            {{
              'One of the items in your cart is no longer available at this price. Please remove it to continue.'
                | translate
            }}
          </p>
        }
        @if (totalPriceData?.calcCheckoutResponse?.errorCode === 'HOTEL_DATES_INVALID') {
          <p class="px-2 text-xs text-red-500">
            {{
              'The hotel stay period must cover the entire duration of the trip. The difference between the dates is allowed to be no more than 1 day. There are no gaps or overlaps between the flight and accommodation dates. Please update the hotel check-in and check-out dates accordingly.'
                | translate
            }}
          </p>
        }
        @if (totalPriceData.totalPriceChangeReasonCode === 'COMBI_TOUR_TRANSFERS') {
          <p class="px-2 text-xs text-kz-primary">
            {{
              'The price has been adjusted to account for transfers and other details that could not be calculated when hotels were individually added.'
                | translate
            }}
          </p>
        }
      </div>
    }
  }
</div>
